import { render, staticRenderFns } from "./ClientTableBody.vue?vue&type=template&id=5d7fa254&"
import script from "./ClientTableBody.vue?vue&type=script&lang=ts&"
export * from "./ClientTableBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports